import React from 'react'
import {observer} from 'mobx-react-lite'
import {SlotComponent} from '../../types/ui'
import {CmsImage} from './cms-image'
import { PromoBanner as PromoBannerType } from '../../types/cms'


export const PromoBanner: SlotComponent<PromoBannerType> = observer(({content}) => {
  if (!content?.image?.images?.length) {
    return null
  }

  return <CmsImage images={content.image.images} width="full" style={{objectFit: 'cover'}} />
})
